import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../../utility/Redux/profile";
import { FromToDate } from "../../../utility/component/fromToDate";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../../utility/Redux/security";
import { SummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../../utility/component/geniusComponents/geniusTableData";
import IsLocalData from "../../../utility/component/isLocalData";
import FromToDateMobile from "../../../utility/component/fromToDateMobile";
import GeniusTableForReports from "../../../utility/component/printReport";
import { Pagination } from "@mui/material";
import { AccountMasterHelp } from "../../../help";
import { setAlertWithTitle } from "../../../utility/Redux/modal";
import GeniustextInput from "../../../utility/component/mastertext";
import { FormatNumber2 } from "../../../utility/functions/formatNumber";

const Account_ledger = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const printRef = useRef(null);
  const [filterType, setFilterType] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [accModalStatus, setAccModalStatus] = useState(false);
  const [accountDeails, setAccountDetails] = useState("");
  const [openingBalDetails, setOpeningBalDetails] = useState("");
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = (page) => {
    if (accountDeails) {
      GetSaleSummary(
        {
          table_prefix: prefix,
          FDATE: moment(fromDate).format("YYYY-MM-DD"),
          TDATE: moment(ToDate).format("YYYY-MM-DD"),
          page: page ? page : currentPage,
        PAGE:page?page:1,

          ACCOUNT_NO: accountDeails?.ACCOUNT_NO,
          ...accountDeails,
        },
        token,
        dispatch,
        setSummaryList,
        setTotalPages,
        setCurrentPage,
        setOpeningBalDetails
      );
    } else {
      dispatch(
        setAlertWithTitle({
          title: "Alert",
          msg: "Select account details first",
        })
      );
    }
  };
  const columns = SummaryColumns(width, openingBalDetails);
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: portrait;
  }
`,
  });

  useEffect(() => {
    const callback = (details, data) => {
      setSummaryList(data);
      setAccountDetails(details[0]);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("account_ledger", callback, elseFunc);
  }, []);
  const difrence = summaryList[0]
    ? summaryList.reduce((acc, row) => acc + Number(row.DEBIT), 0) -
      summaryList.reduce((acc, row) => acc + Number(row.CREDIT), 0)
    : 0;

  return (
    <div className=" bg-white flex flex-col h-full overflow-y-auto   ">
      <div className=" flex flex-col h-full p-3 ">
        <div className="font-semibold pb-2">Account Ledger</div>

        <div>
          {window.innerWidth <= 700 ? (
            <>
              <FromToDateMobile
                onPrintClick={handlePrint}
                submit={() => {
                  okButton();
                }}
              />
            </>
          ) : (
            <FromToDate
              hideReset={true}
              onPrintClick={handlePrint}
              submit={() => {
                okButton();
              }}
              partyData={{
                NAME: accountDeails?.NAME,
              }}
              onPartyMasterSearchClick={() => {
                setAccModalStatus(true);
              }}
              reset={() => {
                setSummaryList([]);
              }}
            />
          )}
        </div>
        <div
          style={{
            width: columns.reduce((acc, row) => acc + Number(row.width), 0),
          }}
          className="flex justify-between mt-3 mb-2 bg-gray-100 rounded-sm p-2"
        >
          <div className="grid grid-cols-1 ">
            <GeniustextInput
              max={15}
              autofocus={true}
              value={accountDeails?.ACCOUNT_NO}
              title={"Account No."}
              titleAlign={"left"}
              type={"text"}
              titleWidth={130}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
            <GeniustextInput
              max={15}
              autofocus={true}
              value={accountDeails?.NAME}
              title={"Account Name"}
              type={"text"}
              titleWidth={130}
              titleAlign={"left"}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
            <GeniustextInput
              max={15}
              autofocus={true}
              align={"right"}
              value={`${openingBalDetails?.CLOSING_BALANCE}  ${openingBalDetails?.CLOSING_BALANCE_TYPE}`}
              title={"Opening Balance"}
              type={"text"}
              titleWidth={130}
              titleAlign={"left"}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
          </div>

          <div className="grid grid-cols-1 ">
            <GeniustextInput
              max={15}
              autofocus={true}
              value={summaryList[0]?.UNDER_GROUP}
              title={"Under Group"}
              titleAlign={"left"}
              type={"text"}
              search={""}
              titleWidth={150}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
            <GeniustextInput
              max={15}
              autofocus={true}
              value={summaryList[0]?.BALANCE_SHEET_CLASS}
              title={"Balance Sheet Class"}
              type={"text"}
              titleWidth={150}
              titleAlign={"left"}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
            <GeniustextInput
              max={15}
              autofocus={true}
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              title={"Show Debit/Credit"}
              option={[
                {
                  name: "Both",
                  value: "",
                },
                {
                  name: "Only Credit",
                  value: "Credit",
                },
                {
                  name: "Only Debit",
                  value: "Debit",
                },
              ]}
              titleWidth={150}
              titleAlign={"left"}
              backgroundColor={"transparent"}
              readOnly={true}
              grid={true}
            />
          </div>
        </div>
        {summaryList[0] ? (
          <div
            style={{
              height: `calc(100% - 180px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <GeniusTableReports
              data={summaryList.filter((s) => {
                if (filterType) {
                  return filterType === "Credit"
                    ? s.CREDIT > 0
                    : filterType === "Debit"
                    ? s.DEBIT > 0
                    : false;
                } else {
                  return true;
                }
              })}
              columns={columns}
              pagination={
                <div
                  style={{
                    width: columns.reduce(
                      (acc, row) => acc + Number(row.width),
                      0
                    ),
                  }}
                  className="flex justify-end mt-1"
                >
                  {" "}
                  <Pagination
                    onChange={(e, v) => {
                      okButton(v);
                    }}
                    sx={{
                      "& .MuiPaginationItem-root": {
                        color: "#000",
                        backgroundColor: "#f3f4f6", // light gray
                        borderRadius: "8px", // rounded rectangle
                        margin: "0 4px",
                        minWidth: "36px",
                        height: "36px",
                      },
                  
                      "& .MuiPaginationItem-root:hover": {
                        backgroundColor: "#e5e7eb",
                      },
                  
                      "& .Mui-selected": {
                        backgroundColor: "#000 !important",
                        color: "#fff !important",
                      },
                  
                      "& .Mui-selected:hover": {
                        backgroundColor: "#000",
                      },
                    }}
                    count={totalPages}
                    page={currentPage}
                  />{" "}
                </div>
              }
              footer={<Footer columns={columns} rows={summaryList} />}
            />
            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                  <div>
                    <GeniusTableForReports
                      customeHeader={
                        <div className="items-center  ">
                          <div className="flex flex-col items-center">
                            <div className="mr-1 text-sm font-semibold flex justify-center ">
                              Trial balance - Opening Balance Wise
                            </div>
                            <div className="flex">
                              <div className="text-sm font-semibold">
                                From :
                              </div>
                              <div className="ml-1 text-sm">
                                {moment(fromDate).format("DD-MM-YYYY")}{" "}
                              </div>
                              <div className="text-sm font-semibold ml-2">
                                To :
                              </div>
                              <div className="ml-1 text-sm">
                                {moment(ToDate).format("DD-MM-YYYY")}{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      data={summaryList}
                      columns={columns}
                      marginTop={"120px"}
                      headerWidth={true}
                      Fotter={
                        <div className=" w-full ">
                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px] text-[15px] ">
                                Total Debit
                              </div>
                              :
                              <div className="ml-1 text-[15px] text-right font-semibold">
                                {summaryList.reduce(
                                  (acc, row) => acc + Number(row.DEBIT),
                                  0
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px]  text-[15px] ">
                                Total Credit
                              </div>
                              :
                              <div className="ml-1 text-[15px]  text-right font-semibold">
                                {summaryList.reduce(
                                  (acc, row) => acc + Number(row.CREDIT),
                                  0
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="flex justify-start text-sm flex-1">
                            <div className="flex items-center ">
                              <div className=" mr-2 font-bold w-[110px]  text-[15px] text-red-500">
                                Diffrence
                              </div>
                              :
                              <div className="ml-1 text-[15px]  text-right font-semibold">
                                {difrence.toFixed(2)}
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}

        <div
          style={{
            width: columns.reduce((acc, row) => acc + Number(row.width), 0),
          }}
          className="flex justify-between text-sm"
        >
          <div className="flex items-center ">
            <div className=" mr-2 font-bold  text-[18px] ">Total Records</div>:
            <div className="ml-1 text-[18px]  text-right font-semibold">
              {summaryList.length}
            </div>
          </div>
          <div className="flex items-center ">
            <div className=" mr-2 font-bold text-[18px] text-red-500">
              Closing Balance
            </div>
            :
            <div className="ml-1 text-[18px]  text-right font-semibold">
              {summaryList[summaryList.length - 1]?.BALANCE
                ? FormatNumber2(
                    summaryList[
                      summaryList.length - 1
                    ]?.BALANCE?.toString().replace("-", "")
                  )
                : ""}
              {summaryList[
                summaryList.length - 1
              ]?.BALANCE?.toString().includes("-")
                ? " Cr"
                : " Dr"}
            </div>
          </div>
        </div>
      </div>
      <AccountMasterHelp
        onRowClick={(p) => {
          setAccModalStatus(false);
          setAccountDetails(p.row);
        }}
        status={accModalStatus}
        onClose={() => {
          setAccModalStatus(false);
        }}
      />
    </div>
  );
};

export default Account_ledger;
